import { Injectable } from '@angular/core';
import { ErrorReportingPort } from '../error-reporting.port';
import { AppError } from '../../services/app-error';
import {
    ErrorReporterBreadcrumbType,
    ErrorReporterMetadata,
    ErrorReporterOptions,
    ErrorReporterUser,
} from '@app/common/observability/domain/services/error-reporter.service';

@Injectable({
    providedIn: 'root',
})
export class NoopErrorReportingAdapter implements ErrorReportingPort {
    public start(): void {
        return;
    }

    public report(error: AppError | unknown, _options?: ErrorReporterOptions): void {
        const message: string = error instanceof AppError ? error.message : 'unknown error';
        console.info('Error reporting disabled. Error not sent to external service:', message);
    }

    public setUser(_user: ErrorReporterUser | null): void {
        return;
    }

    public leaveBreadcrumb(
        _message: string,
        _metadata?: ErrorReporterMetadata,
        _type?: ErrorReporterBreadcrumbType,
    ): void {
        return;
    }
}
